import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';

export type TrueImpactChild =
  | React.ReactElement
  | React.ReactElement[]
  | string
  | number
  | React.ReactNode
  | React.ReactNode[];

interface TrueImpactBadgeProps {
  backgroundColor?: keyof typeof COLORS;
  foregroundColor?: keyof typeof COLORS;
  style?: React.CSSProperties;
  children: TrueImpactChild;
  className?: string;
  onClick?: () => unknown;
}

const StyledSpan = styled.span<{
  backgroundColor: keyof typeof COLORS;
  foregroundColor: keyof typeof COLORS;
  onClick?: () => unknown;
}>`
  font-size: 10px;
  color: ${({ foregroundColor }) => COLORS[foregroundColor]};
  border-radius: ${SPACERS.extraTiny};
  margin-left: ${SPACERS.extraTiny};
  padding: 1px ${SPACERS.extraTiny};
  ${({ onClick }) => onClick && 'cursor: pointer;'}
  background-color: ${({ backgroundColor }) => COLORS[backgroundColor]};
`;

const TrueImpactBadge: React.FC<TrueImpactBadgeProps> = ({
  style,
  children,
  foregroundColor = 'whiteDark',
  backgroundColor = 'brown',
  className,
  onClick,
}) => {
  return (
    <StyledSpan
      style={style}
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      className={className}
      onClick={onClick}
    >
      {children}
    </StyledSpan>
  );
};

export default TrueImpactBadge;
